@if (loading$ | async) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
}

@if ((loading$ | async) === false && (showNoData$ | async)) {
  <div class="mt-28 flex flex-col items-center justify-center space-y-5 text-aux-gray-dark">
    <aux-icon name="FileDescription" />
    <div class="text-xl font-bold">No Investigator Data to Review</div>
  </div>
}

@if ((loading$ | async) === false && (showNoData$ | async) === false) {
  <div>
    <span class="text-base font-bold">Sites Level Actuals</span>

    <span class="ml-4 text-base text-aux-gray-lightest">
      Last Source Data Refresh: {{ lastSourceDataRefreshDate | date: 'MMMM d, y, h:mm a' }}
    </span>
  </div>

  <div class="my-4 flex items-center justify-between space-x-8 text-sm">
    <div class="flex space-x-8">
      <div class="flex items-center">
        <div class="mr-2">Month:</div>
        <ng-select
          class="w-72 tabular-nums"
          bindValue="value"
          bindLabel="label"
          [clearable]="false"
          [searchable]="false"
          [items]="monthList"
          [(ngModel)]="selectedMonthFC"
        />
      </div>

      <div class="flex items-center space-x-2">
        <div>Count</div>
        <aux-toggle [value]="isDisplayCosts" (change)="display$.next($event ? 'costs' : 'count')" />
        <div>Costs</div>
      </div>

      <div class="flex items-center">
        <aux-toggle-currency
          [value]="isContractedCurrency"
          (nameSelectedCurrency)="selectedVisibleCurrency$.next($event)"
        />
      </div>
    </div>

    <div class="flex items-center">
      <div class="mr-2">Version:</div>
      <ng-select
        class="mr-4 w-72 tabular-nums"
        placeholder="Versions"
        [clearable]="false"
        [(ngModel)]="selectedVersion"
        (change)="onVersionChange()"
      >
        @for (version of versions$ | async; track version) {
          <ng-option [value]="version.id">
            {{ version.create_date | date: 'MM.dd.YYYY HH:mm' }}
          </ng-option>
        }
      </ng-select>

      <aux-export-excel-button
        [gridAPI]="gridAPI"
        [excelOptions]="gridOptions"
        [ignoreColsId]="['site_id']"
        [getDynamicExcelParamsCallback]="getDynamicExcelParams"
        pendoTag="investigator-detail-excel-export-button"
      />
    </div>
  </div>

  <ag-grid-angular
    id="investigatorDetailsGrid"
    class="ag-theme-aux mb-4 tabular-nums"
    [rowData]="(gridData$ | async)!"
    [gridOptions]="(gridOptions$ | async)!"
    (gridReady)="onGridReady($event)"
    (firstDataRendered)="sizeColumnsToFit()"
    (gridSizeChanged)="sizeColumnsToFit()"
  />

  <a class="aux-link mb-16 text-xs" [routerLink]="[patientTrackerLink]">
    View Patient Level Reference Table
  </a>
}
